import { RootState } from "../../rootReducer";

export const selectIsLoadingDepartmentsList = (state: RootState) =>
  state.departmentsList.loading;
export const selectDepartmentsListErrorMessage = (state: RootState) =>
  state.departmentsList.error;
export const departmentsListResponse = (state: RootState) =>
  state.departmentsList.departmentsListResponse;
